import { getScreenName } from '../../../Utils/helper';

import { fireEvent } from '../../../Utils/fireEvent';

export const clickedCtaEvent = (ctaText, deeplink, type) => {
  fireEvent({
    category: 'clicked_cta',
    screen_name: getScreenName(),
    page_url: typeof window != 'undefined' ? window.location.href : 'NA',
    cta: ctaText,
    support_variable: type,
    deeplink_value: deeplink,
  });
};

export const discardPopupEvent = (type) => {
  fireEvent({
    category: 'discard_popup',
    screen_name: getScreenName(),
    page_url: typeof window != 'undefined' ? window.location.href : 'NA',
    parent: type,
  });
};

export const servedStrip = (category, type) => {
  fireEvent({
    category,
    screen_name: getScreenName(),
    page_url: typeof window != 'undefined' ? window.location.href : 'NA',
    parent: type,
  });
};

export const viewedResultPage = () => {
  fireEvent({
    category: 'viewed_general_screen',
    screen_name: getScreenName(),
    page_url: typeof window != 'undefined' ? window.location.href : 'NA',
  });
};

export const assessmentText = 'Take the Test';
